import React, { useState, useEffect, useRef } from "react";
import {
  collection,
  addDoc,
  query,
  orderBy,
  onSnapshot,
  serverTimestamp,
  Timestamp
} from "firebase/firestore";
import { Db } from "../firebase";
import { Link } from "react-router-dom";

const ChatRoom = () => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [nickname, setNickname] = useState("");
  const bottomRef = useRef(null);

  useEffect(() => {
    // 7 μέρες πριν από τώρα
    const sevenDaysAgo = Timestamp.fromDate(
      new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
    );

    const q = query(
      collection(Db, "messages"),
      orderBy("createdAt", "asc")
    );

    const unsubscribe = onSnapshot(q, (snap) => {
      const msgs = snap.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .filter((m) => m.createdAt && m.createdAt.toDate() > sevenDaysAgo); // <-- φίλτρο

      setMessages(msgs);

      setTimeout(
        () => bottomRef.current?.scrollIntoView({ behavior: "smooth" }),
        50
      );
    });

    return () => unsubscribe();
  }, []);

  const handleSend = async (e) => {
    e.preventDefault();
    const text = newMessage.trim();
    if (!text || !nickname) return;

    try {
      await addDoc(collection(Db, "messages"), {
        text,
        nickname,
        createdAt: serverTimestamp(),
      });
      setNewMessage("");
    } catch (err) {
      console.error("Send message error:", err);
    }
  };

  return (
    <div className="chatroom-container d-flex flex-column vh-100">
      {/* Header */}
      
      <div className="chatroom-header bg-dark text-white p-2 d-flex justify-content-between align-items-center">
        <h6 className="mb-0"> <a href="https://www.buymeacoffee.com/RozzyM"><img src="https://img.buymeacoffee.com/button-api/?text=Buy me a beer&emoji=&slug=RozzyM&button_colour=FF5F5F&font_colour=ffffff&font_family=Cookie&outline_colour=000000&coffee_colour=FFDD00" /></a>
</h6>
        <Link to="/" className="btn btn-sm btn-outline-light">
          Home
        </Link>

      </div>

      {/* Chat messages */}
      <div className="chatroom-body flex-grow-1 p-2 overflow-auto">
        {messages.map((m) => (
          <div
            key={m.id}
            className={`d-flex mb-2 ${
              m.nickname === nickname ? "justify-content-end" : "justify-content-start"
            }`}
          >
            <div
              className={`p-2 rounded ${
                m.nickname === nickname
                  ? "bg-primary text-white"
                  : "bg-light text-dark"
              }`}
              style={{ maxWidth: "75%" }}
            >
              <small className="fw-bold d-block">{m.nickname}</small>
              {m.text}
            </div>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>

      {/* Footer */}
      <div className="chatroom-footer p-2 border-top">
        <form onSubmit={handleSend} className="row g-2">
          <div className="col-4 col-sm-3">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Όνομα"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
            />
          </div>

          <div className="col-6 col-sm-7">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Γράψε μήνυμα..."
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              autoComplete="off"
            />
          </div>
          <div className="col-2">
            <button className="btn btn-dark w-100 btn-sm" type="submit">
              Στείλε
            </button>

          </div>
        </form>
      </div>
    </div>
  );
};

export default ChatRoom;

